/* eslint-disable react/display-name */
import React from 'react';
import { useParams } from 'react-router-dom';
import { Handle, Position } from 'reactflow';
import EditNodeHeader from './Common/EditNodeHeader';
import { useJourneyStep } from 'api/Journeys';

const MergeEditNode = React.memo(({ data, isConnectable, draggable = false }) => {
    const { id: journeyIdStr } = useParams();
    const journeyId = parseInt(journeyIdStr);
    const { isDisabled, stepId } = data;
    const { data: step } = useJourneyStep(journeyId, stepId);

    const onRemove = async (evt, stepId, edge) => {
        evt.stopPropagation();
        const follow_key_from = edge.key_from;
        // await dispatch(removeNode(id, stepId, { follow_key_from }));
        console.log('turn into mutation', 'removeNode = (id, stepId, payload) => http.remove(`${API_FLOWS_ROUTE}/${id}/steps/${stepId}`, payload);');

    };

    const onDrop = ( event ) => {
        event.preventDefault();
        console.log('dropped');
    };

    const onDragOver = ( event ) => {
        event.preventDefault();
        return false;
    };

    return (
        step ?
            <div className={!isDisabled ? 'flow-merge-node drop-target-available' : 'flow-merge-node disabled'}
                 onDragOver={onDragOver}
                 onDrop={onDrop}
                 draggable={false}>
                <Handle
                    type='target'
                    position={Position.Top}
                    style={{ height: 0, border: 0, background: 'transparent' }}
                    isConnectable={isConnectable}
                />

                <EditNodeHeader step={step} />

                <Handle
                    type='source'
                    position={Position.Bottom}
                    id='match'
                    style={{ height: 13, width: 13, position: 'absolute', background: 'transparent', boxSizing: 'border-box', border: '2px solid transparent', bottom: '0px' }}
                    isConnectable={isConnectable}
                />
            </div>
            : <></>
    );
});

export default MergeEditNode;
